import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { normalizeStatusPageRichText } from '../models/status-page-rich-text-normalizer.utils';

@Pipe({
  name: 'statusPageRichText',
  standalone: true,
  pure: true
})
export class StatusPageRichTextPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: unknown, fallback: string = ''): SafeHtml {
    const source = this.normalizeInput(value);
    const normalized = normalizeStatusPageRichText(source);
    const fallbackHtml = normalizeStatusPageRichText(this.normalizeInput(fallback));
    return this.sanitizer.bypassSecurityTrustHtml(normalized || fallbackHtml);
  }

  private normalizeInput(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).replaceAll('\n', '<br>');
  }
}
